import { UserModel } from 'src/app/model/UserModel';
import { PaymentService } from './../../services/payment.service';
import { Product } from './../../model/UserDetail';
import { AccountService } from './../../services/account.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from 'src/app/services/shared.service';
import { ActiveSessionsReqObj } from 'src/app/model/ApiRequests/ApiReqObj';
import { environment } from 'src/environments/environment';
import { UserDetailResult } from 'src/app/model/UserDetail';
import { CyberPaySetTransactionRequest, CyberPayLogModel, IVATModel } from 'src/app/model/CyberPay';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-renewplanvoice',
  templateUrl: './renewplanvoice.component.html',
  styleUrls: ['./renewplanvoice.component.css']
})

export class RenewplanvoiceComponent implements OnInit {

  processing = false;
  tranSuccess = false;
  tranFailed = false;
  userdetail: UserDetailResult;
  customerBalance: number;
  mdn: string;
  i_account: number;
  i_customer: number;
  amount: number;
  currentProduct: Product;
  remainingAmount: string;
  paymentMethod: string;
  currentUser: UserModel;
  vatModel: IVATModel;
  vat: number;
  totalamount: number;

  constructor(private activatedRoute: ActivatedRoute, private router: Router, private toastr: ToastrService, private sharedService: SharedService, private accountService: AccountService, private paymentService: PaymentService, private authenticationService: AuthenticationService) { }

  ngOnInit() {
    this.vat = environment.vat;
    const acc: number = parseInt(this.activatedRoute.snapshot.queryParamMap.get('acc'));
    this.currentUser = this.authenticationService.getCurrentUser();

    if (!acc || !this.currentUser) {
      this.toastr.error('Error getting service plan details', 'Error');
      this.router.navigateByUrl('/dashboard');
      return;
    }

    this.getRenewalObject(acc);
  }

  UserIsAuthourised(i_account: string, i_customer: string) {
    // deny unauthourised individual accounts
    if (this.currentUser.i_Account != '0') {

      if (this.currentUser.i_Account != i_account) {
        return false;
      }

    } else {

      // deny unauthorised customer accounts
      if (this.currentUser.i_Customer != i_customer) {
          return false;
      }

    }
    return true;
  }

  async getRenewalObject(i_account: number) {

    let model: ActiveSessionsReqObj = {} as ActiveSessionsReqObj;
    model.i_account = i_account;
    model.DownloadType = 'ACC:GetDetail';
    // let res = await this.accountService.getActiveSessionsFromLteHttp(model).toPromise();
    const res = await this.accountService.getAccountDetailFromLteHttp(model.i_account).toPromise();

    if (!res.Status) {
      this.toastr.error(environment.GenericErrorMsg, 'Error');
      return;
    }

    // let userdetail: UserDetailResult = res.Result[0];
    const userdetail: UserDetailResult = res.Result;

    if (!userdetail.i_account) {
      this.toastr.error(environment.GenericErrorMsg, 'Error');
      return;
    }

    if (!this.UserIsAuthourised(userdetail.i_account.toString(), userdetail.i_customer.toString())) {
      this.toastr.error(environment.GenericErrorMsg, 'Error');
      return;
    }

    const voiceproduct = userdetail.Product.Name.toLowerCase().includes('voice');
    if (!voiceproduct) {
      this.router.navigateByUrl('/dashboard');
      return;
    }

    this.userdetail = userdetail;
    this.i_account = userdetail.i_account;
    this.i_customer = userdetail.i_customer;
    this.mdn = userdetail.ID.toString();
    this.currentProduct = userdetail.Product;
    this.remainingAmount = '₦' + userdetail.Balance.toLocaleString();
    const walletRes = await this.accountService.getCustomerBalance(userdetail.i_customer).toPromise();
    if (!walletRes.Status) {
      this.toastr.error(environment.GenericErrorMsg, 'Error');
      return;
    }
    this.customerBalance = Math.round(walletRes.Result);



  }

  setSelectedPaymentMethod(option: string) {
    if (this.amount >= 500) {
      if (option) {
        this.paymentMethod = option;
        return;
      }
    }

    this.toastr.error('Amount must not be less than 500', 'Invalid amount');

  }
  async getVatValue(amount) {
    try {
      const vatResult = await this.paymentService.GetVAT(amount).toPromise();

      if (vatResult.Status != 1) {
        this.toastr.error('Error, VAT retrieval failed');
        return;
      }
      const vatres: IVATModel = vatResult.Result;
      this.vatModel = vatres;
      return vatres;
    } catch (e) {
      console.log(e);
      this.toastr.error('Error, VAT retrieval failed');
      // return;
    }
  }






  Proceed() {
    if (this.paymentMethod == 'cyberpay') {
      this.gotoCyberPay();
    } else if (this.paymentMethod == 'wallet') {
      this.PayWithWallet();
    }

    return;
  }

  async gotoCyberPay() {

    try {
      this.processing = true;
      const userdetail = this.userdetail;

      if (userdetail == undefined) {
        this.processing = false;
        this.toastr.error(environment.GenericErrorMsg, 'Error');
        return;
      }


      const cyberpayReq: CyberPaySetTransactionRequest = {} as CyberPaySetTransactionRequest;
      cyberpayReq.Currency = 'NGN';
      cyberpayReq.Amount = (1 + (this.vat / 100 )) * this.amount * 100;
      cyberpayReq.CustomerEmail = userdetail.Customer.EmailAddress;
      cyberpayReq.CustomerId = userdetail.i_customer.toString();
      cyberpayReq.CustomerMobile = userdetail.Customer.MobilePhone;
      cyberpayReq.CustomerName = `${userdetail.Customer.FirstName} ${userdetail.Customer.LastName}`;
      cyberpayReq.Description = 'Renew Voice Plan ' + userdetail.ID.replace('@msisdn','');
      cyberpayReq.IntegrationKey = environment.voiceIntegrationKey;
      cyberpayReq.MerchantRef = new Date().getTime().toString();
      cyberpayReq.ProductCode = '';
      cyberpayReq.ReturnUrl = environment.CyberPayReturnURL;
      cyberpayReq.WebhookUrl = environment.webhookUrl;

      const res = await this.paymentService.cyberPaySetTransaction(cyberpayReq).toPromise();
      if (!res.succeeded) {
        this.processing = false;
        this.toastr.error('An error occured trying to set transaction, try again', 'Error');
        return;
      }

      const cyberPayLogModel: CyberPayLogModel = {} as CyberPayLogModel;
      cyberPayLogModel.PortalCode = environment.PortalCode;
      cyberPayLogModel.CustomerID = userdetail.i_customer;
      cyberPayLogModel.DateCreated = new Date().toISOString();
      cyberPayLogModel.CustomerDesc = 'CustomerDesc';
      cyberPayLogModel.Email = cyberpayReq.CustomerEmail;

      cyberPayLogModel.FullName = userdetail.Customer.FirstName + ' ' + userdetail.Customer.LastName;

      cyberPayLogModel.ItemCode = '0';
      cyberPayLogModel.ItemName = 'Account Renewal';

      const session = `Account-${userdetail.i_account}-${this.currentUser.UserID}*${new Date().getTime().toString()}`;
      cyberPayLogModel.PhoneNumber = cyberpayReq.CustomerMobile;
      cyberPayLogModel.OperatorID = environment.OperatorID;
      cyberPayLogModel.RedirectLink = res.data.redirectUrl;
      cyberPayLogModel.Request_Payload = JSON.stringify(cyberpayReq);
      cyberPayLogModel.Session = session;
      cyberPayLogModel.TransRef = res.data.transactionReference;
      cyberPayLogModel.Transaction_status = 'PENDING';
      cyberPayLogModel.Value = this.amount;
      cyberPayLogModel.amount = this.amount;
      cyberPayLogModel.AllocateAll = true;
      cyberPayLogModel.i_account = userdetail.i_account;
      cyberPayLogModel.i_customer = userdetail.i_customer;
      cyberPayLogModel.i_product = 0;
      cyberPayLogModel.VAT = (this.vat/ 100) * this.amount;
      cyberPayLogModel.VatPercentage = this.vat;//this.vatModel.VatPercentage;
      cyberPayLogModel.ProdVatPrice = (1+(this.vat/100))*this.amount;// this.vatModel.ProdVatPrice;
      cyberPayLogModel.ActualPayment = (1+(this.vat/100))*this.amount;
      cyberPayLogModel.provider_id = environment.OperatorID;

      await this.paymentService.LteHttpLogCyberPayRequest(cyberPayLogModel).toPromise();
      window.location.href = res.data.redirectUrl;
    } catch (err) {
      this.processing = false;
      this.tranFailed = true;
    }


  }

  async PayWithWallet() {
    if (this.currentUser.i_Account != '0') {
      this.toastr.error('Not available for individual accounts');
      return;
    }
    try {
      this.processing = true;

      if (this.customerBalance < this.amount) {
        this.processing = false;
        this.toastr.error('Your datareserve Balance is not sufficient for transaction', 'insufficient balance');
        return;
      }


let amt=(1+(this.vat/100))*this.amount;
let vatAmount=(this.vat/100)*this.amount;
let vatRate=this.vat;
      const res = await this.paymentService.LteRenewPlanAccountRenewal(this.i_customer, this.i_account,amt,'SELFCARE',vatAmount,vatRate).toPromise();
      if (res.Status) {
        this.processing = false;
        this.tranSuccess = true;
        this.clearform();
        this.getRenewalObject(this.i_account);
        return;
      }

      this.processing = false;
      this.tranFailed = true;
    } catch (err) {
      this.processing = false;
      this.tranFailed = true;
    }

  }

  clearform() {
    this.paymentMethod  = '';

  }
}
